import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import * as React from 'react';

const styles = require('./FolderPermissionsLoader.scss');

/**
 * Loader component which covers the area of folder permissions dialog.
 */
const FolderPermissionsLoader = () => (
    <div className={styles.folderPermissionsSpinnerContainer}>
        <Spinner className={styles.folderPermissionSpinner} size={SpinnerSize.medium} />
    </div>
);

export default FolderPermissionsLoader;
